<template>
  <div>
    <footer class="bg-pinkdark py-3">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-5 d-flex flex-column justify-content-between">
            <div>
              <img src="images/logotype-lg-dark.svg" height="27" alt>
            </div>
            <ul class="mt-5 list-unstyled text-white">
              <li>訂購專線：07-1234-5678</li>
              <li>聯絡我們：lovelysweet@email.com</li>
            </ul>
          </div>
          <div class="col-md-5 text-right d-md-block d-none">
            <img src="images/sm-今天是個吃甜點的好日子.svg" width="60" alt>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-5">
            <a href="https://www.facebook.com/Cookielovelysweet/">
              <i class="fab fa-facebook-square fa-3x text-white"></i>
            </a>
            <a href="https://www.instagram.com/lovely_sweet.cookies/">
              <i class="fab fa-instagram fa-3x text-white"></i>
            </a>
            <a href="https://shopee.tw/amelie525">
              <i class="fab fa-line fa-3x text-white"></i>
            </a>
          </div>
          <div class="col-md-5 text-md-right text-white mt-2">
            <span>© 2019 LovelySweet* 僅供作業使用</span>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>


// WEBPACK FOOTER //
// src/components/footerSection.vue